import { Link } from 'react-router-dom';
import { SEVERITY_WORDS, SEVERITY_CLASS, UNKNOWN_WORD, NO_DOOR_HERE, word } from './words.js';

// ONE AIRGUS ITEM, as the page shows it: the severity as a WORD in its colour,
// the message, the evidence it rests on, and the remedy as a link to the door
// that exists today (href), a button when the caller handles it (onRemedy),
// nothing when the field itself sits on this row (inline), and otherwise the
// label with NO_DOOR_HERE: never a link or a button that opens nothing. An
// unknown item (the rule could not read what it needed) is muted and says
// "we do not know": it is never dressed as an answer. Renders the item;
// derives nothing.

// A remedy href is a route (the term workspace) or a hash (a row of this
// page, doors.js PAGE_DOORS). A hash is a plain anchor so the browser scrolls
// to the row and the input there focuses itself; the router never sees it.
export function RemedyLink({ href, className = '', opener, children, ...rest }) {
  if (String(href).startsWith('#')) return <a href={href} className={`inline-flex min-h-[36px] items-center ${className}`} data-remedy={opener} {...rest}>{children}</a>;
  return <Link to={href} className={`inline-flex min-h-[36px] items-center ${className}`} data-remedy={opener} {...rest}>{children}</Link>;
}

export default function OpenItem({ item, href, onRemedy, inline = false, compact = false }) {
  if (!item) return null;
  const unknown = item.unknown === true;
  // No default: an item without a severity renders the NOT_RECORDED word in
  // the neutral class, never "Note" in the info colour.
  const sev = item.severity ?? null;
  const read = item.evidence?.read || [];
  return (
    <div className={`flex flex-wrap items-start gap-x-3 gap-y-1 ${compact ? 'py-1' : 'py-2'} ${unknown ? 'text-text-dim' : 'text-text'}`} data-item={item.code} data-severity={sev ?? 'not_recorded'} data-unknown={unknown ? 'true' : 'false'}>
      <span className={`inline-flex shrink-0 items-center rounded-pill px-2 py-0.5 text-[11px] font-medium leading-none ${unknown ? 'bg-border/40 text-text-dim' : (SEVERITY_CLASS[sev] || 'bg-border/60 text-text')}`} data-severity-word>
        {unknown ? UNKNOWN_WORD : word(SEVERITY_WORDS, sev)}
      </span>
      <span className="min-w-0 flex-1 text-sm">{item.message}</span>
      {item.remedy ? (
        href ? (
          <RemedyLink href={href} opener={item.remedy.opener} className="inline-flex min-h-[36px] shrink-0 items-center text-sm font-medium text-accent underline-offset-2 hover:underline">{item.remedy.label}</RemedyLink>
        ) : onRemedy ? (
          <button type="button" onClick={() => onRemedy(item)} className="inline-flex min-h-[36px] shrink-0 items-center text-sm font-medium text-accent underline-offset-2 hover:underline" data-remedy={item.remedy.opener}>{item.remedy.label}</button>
        ) : inline ? null : (
          <span className="shrink-0 text-sm text-text-dim" data-remedy={item.remedy.opener} data-no-door>{item.remedy.label}: {NO_DOOR_HERE}</span>
        )
      ) : null}
      {read.length && !compact ? (
        <span className="basis-full text-[11px] text-text-dim" data-evidence>read: {read.join('; ')}</span>
      ) : null}
    </div>
  );
}
